;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);

	$doc.ready(function() {
		//Selects
		$('.select').dropdown();

		$(document).on('click change', '.gatracking', function(event) {
			var target = event.target;
			if(!$.isEmptyObject($(target).data()) && $(this).data('category') != null && typeof ga !== 'undefined') {
				ga('send', 'event', $(target).data('category'), 'click', $(target).data('label'));
			}
		});

		initMobileMenu();

		(function() {
			function mobileMenuOnResize() {
				var $header = $('.header');
				var $topBanner = $('.top-banner');
				var $mobileMenu = $('.menu');
				var visible = $mobileMenu.hasClass('visible');
				var height, offset;

				if (!visible) {
					$mobileMenu.css('opacity', '0').addClass('visible');
				} else {
					$mobileMenu.css('height', '');
				}

				height = $mobileMenu.outerHeight();
				$mobileMenu.data('height', height);

				if (!visible) {
					$mobileMenu.removeClass('visible').css('opacity', '');
				} else {
					$mobileMenu.css('height', height + 'px');
				}

				offset = $header.add($topBanner).get()
					.reduce(function(acc, elem) {
						return acc + $(elem).outerHeight();
					}, 0);
				$mobileMenu.css('top', offset + 'px');
			}

			$win.on('load resize', mobileMenuOnResize);
			mobileMenuOnResize()
		})();

		if ($('.header.header-sticky').length) {
			var prevWidth = $win.width();
			var prevScrollY = -1;
			var breakpoint = 1024;

			prevWidth = prevWidth < breakpoint? breakpoint : 0;

			function stickyHeaderUpdateHandler(testFunc) {
				var $wrapper = $('body > .wrapper');
				var $header = $('.header.header-sticky');
				var $topBanner = $('.top-banner');
				var width = $win.width();
				var scrollY = $win.scrollTop();
				var heights = $topBanner.length && $topBanner.outerHeight();
				var fixed;

				if (!testFunc(heights)) {
					return;
				}

				fixed = scrollY >= heights && width >= breakpoint;

				$wrapper.css('padding-top', fixed? $header.outerHeight(true) + 'px' : '');
				!fixed && $wrapper.scrollTop(0);
				$header.toggleClass('fixed', fixed);
			}

			function handleResizeStickyHeader() {
				var width = $win.width();

				stickyHeaderUpdateHandler(function() {
					return width < breakpoint && prevWidth >= breakpoint || width >= breakpoint && prevWidth < breakpoint;
				});

				prevWidth = width;
			}

			function handleScrollStickyHeader() {
				var scrollY = $win.scrollTop();

				stickyHeaderUpdateHandler(function(offset) {
					return scrollY < offset && prevScrollY >= offset || scrollY >= offset && prevScrollY < offset;
				});

				prevScrollY = scrollY;
			}

			$win.on('resize', handleResizeStickyHeader);
			$win.on('scroll', handleScrollStickyHeader);
			handleResizeStickyHeader();
		}

		//Fullsize Background Image
		$('.fullsize').each(function() {
			var $img = $(this);

			$img.addClass('hidden').parent().addClass('fullsize-container').css('background-image', 'url(' + $img.attr('src') + ')');
		});

		function footerAccordionToggle(trigger, flag) {
			var $trigger = $(trigger);
			var $container = $trigger.closest('.footer-nav-wrapper');
			var $target = $($trigger.attr('href'));

			if ($(window).width() >= 1024) {
				return;
			}

			if (typeof flag === 'undefined') {
				flag = !$container.hasClass('open');
			}

			$container.toggleClass('open', flag);
			$target['slide' + (flag ? 'Down' : 'Up')](300);
		}

		$('.footer-nav-accordion-trigger')
			.on('click', function(e) {
				e.preventDefault();

				footerAccordionToggle(e.currentTarget);
			})
			.each(function(i, trigger) {
				footerAccordionToggle(trigger, false);
			});

		if (typeof $('.select-secondary').selectize != 'undefined') {
			$('.select-secondary').selectize({
				onInitialize: function() {
					var source = this.$input;
					if(!$.isEmptyObject(source.data())) {
						this.$wrapper.data('category', source.data('category'));
						this.$wrapper.data('label', source.data('label'));
						this.$wrapper.addClass('gatracking');
					}
				}
			});
		}

		//Populate label
		$('.field-label').on('keyup', function () {
			var target = $(this).data('target');

			$(target).text($(this).val());
		});

		//Close Promo Bar
		$('.promo-close').on('click', function (e) {
			e.preventDefault();

			$(this).closest('.promo-bar').slideUp();
		});

		$('.slider-product .slides').owlCarousel({
			items: 1,
			margin: 0,
			loop: true,
			dotsEach: true
		});

		//Locations
		if ($('.locations').length) {
			//Initialize ScrollSpy
			var scrollspy = new ScrollSpy({
				linksContainerSelector: '.locations-nav-section',
				sectionSelector: '.section-spy',
				headerOffset: false
			});

			scrollspy.init();

			$win
				.on('load resize', function() {
					scrollspy.refreshPositions();
				});

			var $sidebar = $('.section-sidebar');
			var $content = $('.section-locations .section-content');

			$win.on('scroll', function () {
				var sidebarHeight 		= $sidebar.innerHeight();
				var contentHeight 		= $content.innerHeight();
				var winScroll 			= $win.scrollTop();
				var contentOffset 		= $content.offset().top;

				$sidebar.toggleClass('fixed', winScroll > contentOffset); //Fixed sidebar

				$sidebar.toggleClass('at-bottom', winScroll + sidebarHeight > contentOffset + contentHeight); //absolute sidebar

			});

			/* ACADACA commenting this out
			$('.locations-nav .locations-nav-section a').on('click', function (e) {
				e.preventDefault();

				var target = $(this).attr('href');

				$('html, body').animate({
					scrollTop: $(target).offset().top
				}, 500);

				if ($win.width() < 768) {
					$('dropdown-status span:first-child')
						.removeClass('hidden')
						.siblings()
						.addClass('hidden');

					$('.location-dropdown-toggle-mobile > ul').slideUp();
					$('.section-sidebar').removeClass('expanded')
				}
			}); */

			$('.location-dropdown-toggle').on('click', function () {
				$(this)
					.find('span')
					.toggleClass('hidden')
					.closest('li')
					.siblings()
					.find('.location-dropdown-toggle span:first-child')
					.removeClass('hidden')
					.siblings()
					.addClass('hidden');

				$(this)
					.siblings('ul')
					.stop()
					.slideToggle()
					.parent()
					.siblings()
					.find('ul')
					.slideUp();
			});

			$('.location-dropdown-toggle-mobile').on('click', function () {
				var $toggle = $(this);

				$toggle
					.find('.dropdown-status span')
					.toggleClass('hidden')
					.closest('li')
					.siblings()
					.find('.dropdown-status span:first-child')
					.removeClass('hidden')
					.siblings()
					.addClass('hidden');

				$toggle
					.closest('.locations-nav-section')
					.siblings()
					.find('.dropdown-status span:first-child')
					.removeClass('hidden')
					.siblings()
					.addClass('hidden');

				if ($toggle.parent().is('.locations-nav-section')) {
					$toggle
						.siblings('ul')
						.stop()
						.slideToggle()
						.parent()
						.siblings()
						.find('.has-dropdown-mobile ul')
						.slideUp();
				} else {
					$toggle
						.siblings('ul')
						.stop()
						.slideToggle()
						.parent()
						.siblings()
						.find('ul')
						.slideUp()
						.closest('.locations-nav-section')
						.siblings()
						.find('ul')
						.slideUp();
				}
			});

			$('.sidebar-toggle').on('click', function (e) {
				e.preventDefault();

				$(this).next().toggleClass('visible').parent().toggleClass('expanded');
			});
		}


		//Mask Input
		$('.mask-phone').mask('(999) 999-9999', {placeholder:" "});
		$('.mask-card').mask('9999 9999 9999 9999', {placeholder:" "});

		//Mini cart toggle fields
		$('.mini-cart-item input[type="checkbox"]').on('change', function () {
			var $this = $(this);
			var $item = $(this).closest('.mini-cart-item');
			var $hiddenFields = $item.find('.form-hidden');

			if ($this.prop('checked')) {
				$hiddenFields.removeClass('hidden');
			} else {
				$hiddenFields.addClass('hidden');
			}
		});

		$win.on('click', function (event) {
			var $target = $(event.target);

			if (!$target.parents('.filter-dropdown').length || $target.is('.filter-dropdown')) {
				$('.filter-dropdown').removeClass('expanded');
			}

			if (!$target.parents('.tooltip').length || $target.is('.tooltip')) {
				$('.tooltip').removeClass('opened');
			}
		});

		if ($('.form-scroll').length) {
			var $sectionProduct = $('.section-product');

			$win.on('scroll', function () {
				if ($win.width() < 768) {
					if ($sectionProduct.offset().top + $sectionProduct.innerHeight() > $win.scrollTop() + $win.height()) {
						$('.form-scroll').addClass('fixed');
					} else {
						$('.form-scroll').removeClass('fixed');
					}
				}
			});
		}

		$doc.on('click touchstart', function (event) {
			var $target = $(event.target);

			if ( $target.is($('.mini-cart')) ) {

				if ($('.popup').hasClass('visible')) {
					$('.popup').removeClass('visible');
					$('.mini-cart').removeClass('popup-open');
					$('.mini-cart a.active').removeClass('active');
				} else {
					$('.mini-cart').removeClass('visible');
					$('.mini-cart a.active').removeClass('active');
					$('html').removeClass('no-scroll');
				}
			}

			if ($target.is($('.popup-container')) && !$target.is('.popup-container-required')) {
				$('.popup-container').removeClass('visible')
			}

		});

		//Move Select dropdown Position
		$('.select-fancy select').on('change', function () {
			var $dropdown = $(this).siblings('.fs-dropdown-options');
			var selectedItemIdx = $dropdown.find('.fs-dropdown-item_selected').index();
			var itemHeight = $dropdown.find('.fs-dropdown-item').innerHeight();

			$dropdown.css(
				'transform', 'translateY(-' + (itemHeight * selectedItemIdx) + 'px)'
			);
		});

		//Form Allow Next Steps
		$('.form-next').on('click', function (e) {
			e.preventDefault();

			$(this).closest('form').find('.form-section').toggleClass('disabled');
		});

		//Toggle Product Details
		$('.product-details-toggle').on('click', function (e) {
			e.preventDefault();

			var $toggle = $(this);
			var parent = $toggle.parents('.product-details');
			var $productDetailsInner = parent.find('.product-details-inner');

			$productDetailsInner.addClass('gradient');

			$productDetailsInner.slideToggle(400, function() {
				if (!parent.find('.product-details-inner').is(':visible')) {
					if (js_site_var['userLanguage'] == 'FR')
						$toggle.html('En savoir plus');
					else
						$toggle.html('view more');
				} else {
					if (js_site_var['userLanguage'] == 'FR')
						$toggle.html('lire moins');
					else
						$toggle.html('view less');
				}
			});

			setTimeout(function () {
				$productDetailsInner.removeClass('gradient');
			}, 400);

		});

		//Toggle Filter
		$('.filter-dropdown-toggle').on('click', function (e) {
			e.preventDefault();

			$('.filter-dropdown-toggle').not($(this)).parent().removeClass('expanded');

			$(this).parent().toggleClass('expanded');
		});

		//Toggle Tooltips
		$('.tooltip-toggle').on('click', function () {

			$('.tooltip-toggle').not($(this)).parent().removeClass('opened');

			$(this).closest('.tooltip').toggleClass('opened');l
		});

		//Toggle Search
		$('.filter .search-btn').on('click', function (e) {
			if ( $win.width() < 1024 && $win.width() > 767 && !$('.filter .search').hasClass('expanded')) {
				$('.filter .search').addClass('expanded');
				$('.filter .search-field').focus();

				e.preventDefault();
			}
		});

		$('.search-close').on('click', function (e) {
			e.preventDefault();

			$(this).closest('.search').removeClass('expanded');
		});

		//Show Popups
		$('.popup-toggle').on('click', function (e) {
			e.preventDefault();

			var target = $(this).attr('href');

			$(this).toggleClass('active');
			$(target).toggleClass('visible');
			$('.mini-cart').toggleClass('popup-open');
		});

		$('.popup .popup-toggle').on('click', function(event) {
			event.preventDefault();

			var element = $(this).attr('href');

			$('.mini-cart')
				.find('a[href="' + element + '"]')
				.removeClass('active');
		});

		//Toggle
		$('.link-toggle').on('click', function (e) {
			e.preventDefault();

			var target = $(this).attr('href');

			$(this).children().toggleClass('visible');

			$(target).stop().fadeToggle();
		});

		$('.subscribe-field').on('keyup', function () {
			if ($(this).val() !== '') {
				$(this).closest('.subscribe').addClass('typed');
			} else {
				$(this).closest('.subscribe').removeClass('typed');
			}
		})

		$('.subscribe form').on('submit', function (e) {
			e.preventDefault();

			if ( $('.subscribe-field').val() !== '' ) {
				$('.subscribe-label span').toggleClass('visible');

				$('.subscribe-btn').attr('disabled', 'disabled');
			}
		});

		//Scent Page - header main menu
		$('.scents-tab-link').on('click', function(evt){
			var pageUrl = window.location.href;
			var $elem = $(evt.currentTarget);
			var href = $elem.prop('href');
			var anchor = $elem.data('anchorlink');

			pageUrl = pageUrl.slice(0, pageUrl.indexOf('#'));
			href = href.slice(0, href.indexOf('#'));

			if (pageUrl !== href) {
				return;
			}

			evt.preventDefault();
			$('.scents-tabs .tab-link[href="' + anchor + '"]').click();
			mobileMenuToggle(false);
		});

		//Tabs
		function tabClick(tabButton, target) {
			var $tabButton = $(tabButton);
			var $target = $(target);
			var $list = $tabButton.siblings('.tab-button');
			var $neighbors = $target.siblings('.tab-content');

			$list.removeClass('selected');
			$tabButton.addClass('selected');

			$neighbors.removeClass('active');
			$target.addClass('active');
		}

		$('.tabs .tab-buttons .tab-button').on('mouseenter touchstart', function (event) {
			var $elem = $(event.currentTarget);
			var target = $elem.data('target');

			tabClick($elem, target);
		}).on('mouseleave touchend', function(event) {
			var $elem = $(event.currentTarget);

			$elem.removeClass('active');
		}).on('click', function (event) {
			var $tabButton = $(event.currentTarget);
			var target = $tabButton.data('target');

			tabClick($tabButton, target);
		}).find('.tab-link').on('click', function (event) {
			event.preventDefault();

			let linkUrl = $(this).attr('href');
			if (linkUrl !== undefined && linkUrl !== null && linkUrl[0] !== '#') {
				window.open(linkUrl);
				return;
			}

			var $link = $(event.target);
			var href = $link.attr('href');
			var target = (href && href[0] === '#'? href.length > 1 && href : href) || $link.data('target');
			var $target = $(target);

			if (!$target.length) {
				return;
			}

			var $tabButton = $link.closest('.tab-button');

			tabClick($tabButton, target);
		});

		$('.tabs .tab-buttons .tab-button.active').click();

		$('.video-post-product-tab-content').on('click', function(e) {
			e.preventDefault();

			let linkUrl = $(this).data('linkUrl');
			if (linkUrl !== undefined && linkUrl !== null) {
				window.open(linkUrl);
			}
		});

		//About Page
		function scrollToAnchor(target, offset) {
			var $header = $('.header.header-sticky');
			var $target = $(target);
			var anchor = '#' + $target.prop('name');

			var urlParts = window.location.href.split(/\?/);
			var newUrl = urlParts[0].split(/#/)[0] + anchor + (urlParts.length > 1? urlParts[1] : '');

			window.history.pushState('', '', newUrl);
			$('html, body').animate({
				scrollTop: $header.get().reduce(function(acc, elem) {
					return acc - $(elem).outerHeight();
				}, $target.offset().top + 45 + offset)
			});
		}

		//About Page - header main menu
		$('.about-tab-link').on('click', function(evt) {
			var $elem = $(evt.target);
			var $navExpand;
			var href = $elem.prop('href');
			var hrefIdIndex = href.indexOf('#');
			var anchor = href.slice(hrefIdIndex + 1).replace(/\?.+$/, '');
			var $anchor = $('.about-anchor[name="' + anchor + '"]');

			if (!$anchor.length) {
				return;
			}

			evt.preventDefault();

			$navExpand = $elem.closest('.nav-expand-section');
			scrollToAnchor($anchor, -$navExpand.outerHeight());
			mobileMenuToggle(false);
		});

		$win.on('load', function(evt) {
			evt.preventDefault();

			if (!$('.about-anchor').length) {
				return;
			}

			var pageUrl = window.location.href;
			var anchorMatch = pageUrl.match(/#([^\?]+)/);

			if (anchorMatch && anchorMatch.length) {
				scrollToAnchor($('.about-anchor[name="' + anchorMatch[1] + '"]'), 0);
			}
		});

		//Search autocomplete
		var tags = [];

		$('.search-tags span').each(function () {
			tags.push($(this).text());
		});

		$('.autocomplete-field').autocomplete({
			source: tags
		});

		//Remove Filter Tag
		$('.filter-tag').on('click', function () {
			var $separator = $(this).prev('.filter-tag-separator');

			if ( $(this).is(':first-of-type')) {
				$separator = $(this).next('.filter-tag-separator');
			}

			$(this).remove();
			$separator.remove();
		});

		//Clear Filter Tags
		// $('.filter-clear').on('click', function (e) {
		// 	e.preventDefault()

		// 	$('.filter-tag').remove();
		// });

		function mobileMenuToggle(flag) {
			var $target = $('.btn-menu');
			var $wrapper = $('.wrapper');
			var $menu = $('.menu');
			var $html = $('html');
			var height;

			$wrapper.toggleClass('expanded', flag);
			$target.toggleClass('active', flag);
			$html.toggleClass('no-scroll', flag);

			if (flag) {
				$menu.css('height', $menu.data('height') + 'px');
				setTimeout(function() {
					$menu.css('height', '');
					$menu.toggleClass('visible', flag);
				}, 250);
			} else {
				height = $menu.outerHeight();
				$menu.data('height', height).css('height', height + 'px');
				setTimeout(function() {
					$menu.css('height', '');
					$menu.toggleClass('visible', flag);
				}, 250);
			}
		}

		$('.btn-menu').on('click', function(e) {
			var $target = $(this);
			var visible = $target.hasClass('active');

			e.preventDefault();

			mobileMenuToggle(!visible);
		});

		//Select Placeholder
		$('.form-contact select').on('change', function () {
			$(this).parent().addClass('changed');
		});

		$('.nav .has-dropdown > .dropdown-button').on('click', function (e) {
			var $elem = $(this);
			var isOpen = $elem.hasClass('clicked');
			
			if ($win.width() >= 1024 || (isOpen && !$(e.target).is('.ico-arrow-down') && $elem.is('a'))) {
				return;
			}

			e.preventDefault();

			var $menu = $('.menu');

			$menu.css('height', $menu.outerHeight() + 'px');

			if (isOpen) {
				$elem
					.removeClass('clicked')
					.next()
					.slideUp();
			} else {
				$elem
					.addClass('clicked')
					.next()
					.slideDown()
					.parent()
					.siblings()
					.children('.dropdown-button')
					.removeClass('clicked')
					.next()
					.slideUp();

				$menu.css('height', $menu.outerHeight() + 'px');

				setTimeout(function () {
					$menu.css('height', '');
				}, 250);
			}
		}).append('<span class="icon ico-arrow-down"></span>');

		//Slider Lab Images
		function sliderNavUpdateText(e) {
			var $target = $(e.target);
			var $slider = $target.closest('.slider');
			var $text = $slider.find('.slider-nav-text');
			var label = $slider.find('.owl-item .slide').eq(e.item.index).data('label');

			$text.text(label);
		}

		var $sliderLabImages = $('.slider-lab-images .slides');
		$sliderLabImages.owlCarousel({
			items: 1,
			loop: false,
			nav: false,
			dots: true,
			onInitialized: sliderNavUpdateText,
			onChanged: sliderNavUpdateText,
			margin: 0,
		});

		$sliderLabImages.on('changed.owl.carousel', function(e) {
			var $text = $sliderLabImages.closest('.slider-lab-images').find('.slider-nav-text');
			var label = $sliderLabImages.find('.owl-item .slide').eq(e.item.index - 1).data('label');

			$text.text(label);
		});

		//Slider Souls
		var $sliderSoulsDesktop = $('.slider-souls-desktop .slides');
		$sliderSoulsDesktop.owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: true,
			autoplay: true,
			autoplayTimeout: 10000,
			autoplaySpeed: 1000,
			autoplayHoverPause: true
		});

		var $sliderSoulsMobile = $('.slider-souls-mobile .slides');
		$sliderSoulsMobile.owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: true,
			onInitialized: sliderNavUpdateText,
			onChanged: sliderNavUpdateText
		});

		//Slider Collections
		var $sliderCollections = $('.slider-collections .slides');
		$sliderCollections.owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: true
		});

		var $sliderColImages = $('.sliderArea .slides');
		$sliderColImages.owlCarousel({
			items: 2,
			loop: false,
			nav: false,
			dots: true,
			onInitialized: sliderNavUpdateText,
			onChanged: sliderNavUpdateText,
			margin: 10,
			slideBy: 2
		});

		// //Slider Lab Images
		// function sliderNavUpdateText(e) {
		// 	var $target = $(e.target);
		// 	var $slider = $target.closest('.slider');
		// 	var $text = $slider.find('.slider-nav-text');
		// 	var label = $slider.find('.owl-item .slide').eq(e.item.index).data('label');

		// 	$text.text(label);
		// }

		// var $sliderLabImages = $('.slider-lab-images .slides');
		// $sliderLabImages.owlCarousel({
		// 	items: 1,
		// 	margin: 0,
		// 	loop: true,
		// 	nav: false,
		// 	dots: false,
		// 	onInitialized: sliderNavUpdateText,
		// 	onChanged: sliderNavUpdateText
		// });

		// $('.slider-lab-images .slider-prev').on('click', function (e) {
		// 	e.preventDefault();

		// 	$sliderLabImages.trigger('prev.owl.carousel');
		// });

		// $('.slider-lab-images .slider-next').on('click', function (e) {
		// 	e.preventDefault();

		// 	$sliderLabImages.trigger('next.owl.carousel');
		// });

		// $sliderLabImages.on('changed.owl.carousel', function(e) {
		// 	var $text = $sliderLabImages.closest('.slider-lab-images').find('.slider-nav-text');
		// 	var label = $sliderLabImages.find('.owl-item .slide').eq(e.item.index - 1).data('label');

		// 	$text.text(label);
		// });

		// //Slider Souls
		// var $sliderSoulsDesktop = $('.slider-souls-desktop .slides');
		// $sliderSoulsDesktop.owlCarousel({
		// 	items: 1,
		// 	loop: true,
		// 	nav: false,
		// 	dots: false,
		// 	autoplay: true,
		// 	autoplayTimeout: 10000,
		// 	autoplaySpeed: 1000,
		// 	autoplayHoverPause: true
		// });

		// var $sliderSoulsMobile = $('.slider-souls-mobile .slides');
		// $sliderSoulsMobile.owlCarousel({
		// 	items: 1,
		// 	loop: true,
		// 	nav: false,
		// 	dots: false,
		// 	onInitialized: sliderNavUpdateText,
		// 	onChanged: sliderNavUpdateText
		// });

		// $('.slider-souls-mobile .slider-prev').on('click', function (e) {
		// 	e.preventDefault();

		// 	$sliderSoulsMobile.trigger('prev.owl.carousel');
		// });

		// $('.slider-souls-mobile .slider-next').on('click', function (e) {
		// 	e.preventDefault();

		// 	$sliderSoulsMobile.trigger('next.owl.carousel');
		// });

		// //Slider Collections
		// var $sliderCollections = $('.slider-collections .slides');
		// $sliderCollections.owlCarousel({
		// 	items: 1,
		// 	loop: true,
		// 	nav: false,
		// 	dots: true
		// });

		// Replace Password Dots with Asterisks
		$('.field-password').each(function() {
			var $this = $(this);
			var field = document.getElementById($this.attr('id'));
			var label = "";

			function replaceText(){
				if(field.value.length > label.length){
				   label += field.value.substr(label.length, field.value.length);
				}

				if(field.value.length > 0){
					field.value = Array(field.value.length).join("*") + field.value.substr(field.value.length - 1, field.value.length);
				}

				to = setTimeout(replaceText,10);
			}

			var to = setTimeout(replaceText,10);
		});

		var breakpoint = 1024;
		var winWidth = $win.width() < breakpoint? breakpoint : breakpoint - 1;

		$win.on('resize', function() {
			var width = $win.width();

			if ((width < breakpoint && winWidth < breakpoint) || (width >= breakpoint && winWidth >= breakpoint)) {
				return;
			}

			if (width >= breakpoint) {
				winWidth = width;
				return;
			}

			var $filterNav = $('.section-filter');

			$filterNav.css('top', '');
			winWidth = width;
		});

		$win.on('scroll', function() {
			var width = $win.width();

			if (width < breakpoint) {
				return;
			}

			var $filterNav = $('.section-filter:visible').eq(0);

			if (!$filterNav.length) {
				return;
			}

			var $headerSticky = $('.header.header-sticky');
			var scrollY = $win.scrollTop();
			var navOffset;

			$filterNav.css('position', 'static');
			navOffset = $filterNav.offset().top;
			$filterNav.css('position', '');
			$filterNav.toggleClass('fixed', scrollY > navOffset);

			if ($headerSticky.length) {
				$filterNav.css('top', $headerSticky.hasClass('fixed')? $headerSticky.outerHeight() + 'px' : $filterNav.hasClass('fixed')? 0 : '');
			} else {
				$filterNav.css('top', $filterNav.hasClass('fixed')? 0 : '');
			}
		});

		if ( $win.width() < 768 ) {
			$('#field-personalize-label, #field-personalize-engraving, #field-personalize-box').on('blur', function() {
			    $('html, body').animate({
			        scrollTop: $('.product-image').offset().top
			    }, 300);
			});
		}

	    $win.on('load', function() {
			if ($('.form-checkout').length > 0) {
				var $target = $('.form-checkout .form-row.required').first();
				if ($target.length) {
					$('html, body').animate({
						'scrollTop' : $target.offset().top - 40
					}, 200);
				}
			}
	    });
	});

	$.fn.equalizeHeight = function() {
		var maxHeight = 0, itemHeight;
	 
		for (var i = 0; i < this.length; i++) {
			itemHeight = $(this[i]).height('auto').height();
			if (maxHeight < itemHeight) {
				maxHeight = itemHeight;
			}
		}
	 
		return this.height(maxHeight);
	}
})(jQuery, window, document);

var ScrollSpy = function(options) {
		var _spy = this;
		
		_spy.linksContainerSelector = options.linksContainerSelector;
		_spy.sectionSelector = options.sectionSelector;
		
		_spy.$linksContainer = $(_spy.linksContainerSelector);
		_spy.$links = _spy.$linksContainer.find('a');
		_spy.$sections = $(_spy.sectionSelector);
		_spy.headerOffset = options.headerOffset;
		
		_spy.currentIdx = 0;
		_spy.data = {
			offsets: [],
			ids: []
		};
	};
	
	ScrollSpy.prototype.getPositions = function() {
		var _spy = this;
		var data = _spy.data;
		
		for(var i = 0; i < _spy.$sections.length; i++) {
			var $section = _spy.$sections.eq(i);
			
			data.ids.push($section.attr('id'));
			data.offsets.push($section.offset().top);
		}
	};
	
	ScrollSpy.prototype.refreshPositions = function() {
		var _spy = this;
		var data = _spy.data.offsets;
		
		for(var i = 0; i < _spy.$sections.length; i++) {
			var $section = _spy.$sections.eq(i);
			
			data[i] = $section.offset().top;
		}
	};
	
	ScrollSpy.prototype.getCurrentSection = function() {
		var _spy = this;
		var data = _spy.data;
		var scrollTop = $(window).scrollTop();
		
		if(_spy.headerOffset === true) {
			scrollTop += _spy.$linksContainer.outerHeight();
		}
		
		for(var i = 0; i < data.offsets.length; i++) {
			var currentOffset = data.offsets[i];
			var nextOffset = data.offsets[i+1];
			
			if(scrollTop >= currentOffset && scrollTop < nextOffset || 
			   scrollTop >= currentOffset && typeof nextOffset === 'undefined') {
				_spy.currentIdx = i;
				break;
			}
		}
		
		_spy.setCurrent();
	};
	
	ScrollSpy.prototype.setCurrent = function() {
		var _spy = this;
		
		 _spy.$links.eq(_spy.currentIdx)
			 .parent()
				 .addClass('current')
			 .siblings()
				 .removeClass('current')
			 .parent()
			 .closest('li')
			 .siblings()
				.find('.current')
				.removeClass('current')

		 _spy.$links.eq(_spy.currentIdx)
			 .closest('.locations-nav-section')
			 .siblings()
				.find('.current')
				.removeClass('current');

	};
	
	ScrollSpy.prototype.scrollToCurrentSection = function() {
		var _spy = this;
		
		var newTop = _spy.data.offsets[_spy.currentIdx];
		
		if(_spy.headerOffset === true) {
			newTop -= _spy.$linksContainer.outerHeight();
		}
		
		$('html, body').animate({
			scrollTop: newTop
		}, {
			duration: 500,
			queue: false
		});
	};
	
	ScrollSpy.prototype.bindEvents = function() {
		var _spy = this;
		var $win = $(window);
		
		_spy.$links
			.on('click.scrollSpy', function(e) {
				// ACADACA commenting this out
				// e.preventDefault();
				
				_spy.currentIdx = $(this).parent().index();
				// _spy.scrollToCurrentSection();
			});
		
		$win.on('scroll.scrollSpy', function() {
			_spy.getCurrentSection();
		});
	};
	
	ScrollSpy.prototype.init = function() {
		var _spy = this;
		
		_spy.getPositions();
		_spy.getCurrentSection();
		_spy.setCurrent();
		_spy.bindEvents();
	};

function initRegionSelection(options) {
	if (!options) {
		options = {};
	}

	function dataRenderer(className) {
		return function(region, escape) {
			var country = escape(region.country);
			var language = region.language && escape(region.language);

			return (
				'<div class="' + className + '">' +
					'<span class="country">' + country + '</span>' +
					(language? ' - <span class="language">' + language + '</span>' : '') +
				'</div>'
			);
		}
	}

	/* Pre-populate the country based on query param */
	var parsableURI = new URI(location.href);
	var dataMap = parsableURI.search(true);

	var defaultRegion = dataMap['defaultRegion'];
	var selectedRegion = getCookieWithHelper(false, 'acdc_region');
	var selectedLanguage = js_site_var['userLanguage'];
	var emptySelectionLabel = (
		selectedLanguage === 'FR'?
			'Sélectionnez Expédition Pays' :
			'Select Shipping Location'
	);

	var regions = [
		{ id: '', country: emptySelectionLabel },
		{ id: 'US', country: 'United States' },
		{ id: 'CA', country: 'Canada', language: 'English' },
		{ id: 'CA[FR]', country: 'Canada', language: 'Français' },
		{ id: 'AU', country: 'Australia' },
		{ id: 'GB', country: 'Great Britain' },
		{ id: 'FR', country: 'France', language: 'English' },
		{ id: 'FR[FR]', country: 'France', language: 'Français' },
		{ id: 'DE', country: 'Germany' },
		{ id: 'TW', country: 'Taiwan, China' },
		{ id: 'JP', country: 'Japan', language: '日本語' },
		{ id: 'IT', country: 'Italy' },
		{ id: 'CN', country: 'China' },
		{ id: 'HK', country: 'Hong Kong', language: 'English' },
		{ id: 'AL', country: 'Albania' },
		{ id: 'AD', country: 'Andorra' },
		{ id: 'AR', country: 'Argentina' },
		{ id: 'AU', country: 'Australia' },
		{ id: 'AT', country: 'Austria' },
		{ id: 'BH', country: 'Bahrain' },
		{ id: 'BE', country: 'Belgium', language: 'English' },
		{ id: 'BE[FR]', country: 'Belgium', language: 'Français' },
		{ id: 'BR', country: 'Brazil' },
		{ id: 'BG', country: 'Bulgaria' },
		{ id: 'CA', country: 'Canada', language: 'English' },
		{ id: 'CA[FR]', country: 'Canada', language: 'Français' },
		{ id: 'CL', country: 'Chile' },
		{ id: 'CN', country: 'China' },
		{ id: 'HR', country: 'Croatia' },
		{ id: 'CY', country: 'Cyprus' },
		{ id: 'CZ', country: 'Czech Republic' },
		{ id: 'DK', country: 'Denmark' },
		{ id: 'EG', country: 'Egypt' },
		{ id: 'EE', country: 'Estonia' },
		{ id: 'FI', country: 'Finland' },
		{ id: 'FR', country: 'France', language: 'English' },
		{ id: 'FR[FR]', country: 'France', language: 'Français' },
		{ id: 'DE', country: 'Germany' },
		{ id: 'GB', country: 'Great Britain' },
		{ id: 'GR', country: 'Greece' },
		{ id: 'GG', country: 'Guernsey' },
		{ id: 'HU', country: 'Hungary' },
		{ id: 'IS', country: 'Iceland' },
		{ id: 'ID', country: 'Indonesia' },
		{ id: 'IN', country: 'India' },
		{ id: 'IE', country: 'Ireland' },
		{ id: 'IM', country: 'Isle of Man' },
		{ id: 'IL', country: 'Israel' },
		{ id: 'IT', country: 'Italy' },
		{ id: 'JP', country: 'Japan', language: '日本語' },
		{ id: 'JE', country: 'Jersey' },
		{ id: 'KE', country: 'Kenya' },
		{ id: 'KW', country: 'Kuwait' },
		{ id: 'LT', country: 'Lithuania' },
		{ id: 'LV', country: 'Latvia' },
		{ id: 'LU', country: 'Luxembourg', language: 'English' },
		{ id: 'LU[FR]', country: 'Luxembourg', language: 'Français' },
		{ id: 'MY', country: 'Malaysia' },
		{ id: 'MT', country: 'Malta' },
		{ id: 'MX', country: 'Mexico' },
		{ id: 'ME', country: 'Montenegro' },
		{ id: 'MC', country: 'Monaco', language: 'English' },
		{ id: 'MC[FR]', country: 'Monaco', language: 'Français' },
		{ id: 'NL', country: 'The Netherlands' },
		{ id: 'NZ', country: 'New Zealand' },
		{ id: 'ND', country: 'Northern Ireland' },
		{ id: 'NO', country: 'Norway' },
		{ id: 'PH', country: 'Philippines' },
		{ id: 'PL', country: 'Poland' },
		{ id: 'PT', country: 'Portugal' },
		{ id: 'PR', country: 'Puerto Rico' },
		{ id: 'QA', country: 'Qatar' },
		{ id: 'RO', country: 'Romania' },
		{ id: 'RU', country: 'Russia', language: 'Русский' },
		{ id: 'SS', country: 'Scotland' },
		{ id: 'SG', country: 'Singapore' },
		{ id: 'SK', country: 'Slovakia' },
		{ id: 'SI', country: 'Slovenia' },
		{ id: 'ES', country: 'Spain' },
		{ id: 'CH', country: 'Switzerland', language: 'English' },
		{ id: 'CH[FR]', country: 'Switzerland', language: 'Français' },
		{ id: 'ZA', country: 'South Africa' },
		{ id: 'KR', country: 'South Korea' },
		{ id: 'SE', country: 'Sweden' },
		{ id: 'TW', country: 'Taiwan, China' },
		{ id: 'TH', country: 'Thailand' },
		{ id: 'TR', country: 'Turkey' },
		{ id: 'AE', country: 'United Arab Emirates' },
		{ id: 'VA', country: 'Vatican' },
		{ id: 'VN', country: 'Vietnam' },
		{ id: 'WA', country: 'Wales' }
	];
	var selectizeSettings = {
		valueField: 'id',
		searchField: 'country',
		options: regions,
		render: {
			option: dataRenderer('option'),
			item: dataRenderer('item')
		},
		onInitialize: function() {
			var source = this.$input;
			if(!$.isEmptyObject(source.data())) {
				this.$wrapper.data('category', source.data('category'));
				this.$wrapper.data('label', source.data('label'));
				this.$wrapper.addClass('gatracking');
			}
		}
	};
	var selectize = $('#userSettingRegion').selectize(selectizeSettings)[0].selectize;
	var value;

	if (selectedRegion) {
		value = selectedRegion;
	} else {
		switch (defaultRegion) {
			case 'CA':
			case 'AU':
				value = defaultRegion;
				break;
			default:
				value = getCookieWithHelper(false, 'DEFAULT_ACDC_REGION') || '';
		}
	}

	selectize.setValue(value);

	selectize.showInput = (function() {
		var $controlInputItem = this.$control.find('.item');
		var innerSpace = this.$control.innerWidth() - this.$control.width();
		var inputItemWidth = $controlInputItem.outerWidth();
		var calculatedSpace = inputItemWidth + innerSpace;

		this.$control_input.css({
			opacity: 1,
			position: 'relative',
			left: Math.ceil(inputItemWidth) + 'px',
			maxWidth: 'calc(100% - ' + Math.ceil(calculatedSpace)  + 'px) !important'
		});
		$controlInputItem.css('max-width', 'calc(100% - ' + Math.ceil(innerSpace) + 'px)');

		this.isInputHidden = false;
	}).bind(selectize);

	selectize.hideInput = (function() {
		var self = this;
		var $controlInputItem = this.$control.find('.item');

		self.setTextboxValue('');
		self.$control_input.css({
			opacity: 0,
			position: 'absolute',
			left: self.rtl ? 10000 : -10000,
			maxWidth: ''
		});
		$controlInputItem.css('max-width', '');

		self.isInputHidden = true;
	}).bind(selectize);

	selectize.on('item_remove', function() {
		selectize.$control_input.css('left', '0px');
	});

	$('#userSettingRegion').change(function(event){
		var selectedUserRegion = $('#userSetting #userSettingRegion').val();

		setCookieWithHelper(false, 'acdc_region', selectedUserRegion, {
			expires: 30,
			path: '/',
			domain: js_site_var['cookie_domain']
		});
	});

	$('#submit-link').click(function(event) {
		event.preventDefault();

		var parsableURI = new URI(location.href);
		var dataMap = parsableURI.search(true);
		var redirectPath;
		var redirectURI;
		var selectedUserRegion = $('#userSetting #userSettingRegion').val();
		var selectedUserCountry;
		var selectedUserLanguage;

		function addSearchParams() {
			// redirect to the desired page with the cookie set
			for (var key in dataMap) {
				if (dataMap.hasOwnProperty(key)) {
					if (key != 'path') {
						redirectURI.addSearch(key, dataMap[key]);
					}
				}
			}
		}

		if (dataMap['path'] != undefined && "" != dataMap['path']) {
			// remove domain if it's there to make sure path is always relative
			var cleanedPath = dataMap['path'].replace(internationalURI, '');
			redirectPath = cleanedPath;
		} else {
			redirectPath =  options.redirectPath || window.location.pathname;
		}

		redirectURI = new URI (redirectPath);

		if (selectedUserRegion.includes("[FR]") ) {
			selectedUserLanguage = 'FR';
			selectedUserRegion = selectedUserRegion.replace("[FR]", "");
		} else {
			selectedUserLanguage = 'EN';
		}

		selectedUserCountry = selectedUserRegion;

		$.removeCookie('OptanonAlertBoxClosed', { path: '/' });

		switch (selectedUserRegion) {
			case '':
				$('.country-required').show();
				return false;
			case 'JP':
				window.location.href = "http://www.lelabofragrances.jp/";
				return false;
			case 'RU':
				window.location.href = "https://lelabofragrances.ru/";
				return false;
			case 'CA':
				addSearchParams();

				redirectURI.addSearch('region', 'CA').addSearch('locale', selectedUserLanguage);

				window.location.replace(canadaURI + redirectURI);
				return false;
			case 'AU':
				addSearchParams();

				window.location.replace(australiaURI + redirectURI);
				return false;
			case 'WA':
			case 'ND':
			case 'SS':
				selectedUserRegion = 'GB';
				break;
			default:
		}

		setCookieWithHelper(false, 'ACDC_LOCALE', selectedUserLanguage, { expires: 30, path: '/', domain: js_site_var['cookie_domain'] });
		setCookieWithHelper(false, 'acdc_country_code', selectedUserCountry, { expires: 30, path: '/', domain: js_site_var['cookie_domain'] });
		let selectedUserCountryName = countryMap[selectedUserCountry];
		setCookieWithHelper(false, 'acdc_country', selectedUserCountryName, { expires: 30, path: '/', domain: js_site_var['cookie_domain'] });
		setCookieWithHelper(false, 'acdc_region', selectedUserRegion, { expires: 30, path: '/', domain: js_site_var['cookie_domain'] });
		setCookieWithHelper(false, 'acdc_int_region', selectedUserRegion, { expires: 30, path: '/',	domain: js_site_var['cookie_domain']  });

		setCurrencyBasedOnRegion(selectedUserRegion);
		setVATBasedOnRegion(selectedUserRegion);

		addSearchParams();
		
		// For dynamic app pages, we must reload for the server side code to pickup the newly created cookies
		var uri = new URI(window.location.href);
		if(uri.path().startsWith("/front")) {
			window.location = redirectURI;
			return false;
		}
	
		js_site_var['userCountry'] = getCookieWithHelper(false, 'acdc_country');
		js_site_var['userCurrency'] = getCookieWithHelper(false, 'acdc_currency');
		js_site_var['userVAT'] = getCookieWithHelper(false, 'acdc_vat');
		js_site_var['userRegion'] = getCookieWithHelper(false, 'acdc_region');
		$('.footer .showcountry').html(js_site_var['userCountry']);

		// Instead of reloading the page, for SEO purposes, we will just remove the overlay and initialize any code that needs the newly created cookies above for rendering
		if (typeof initPDP != 'undefined') {
			initPDP();
		} 
		if (typeof initCatPage != 'undefined') {
			initCatPage();
		}
		if (typeof initCmsPage != 'undefined') {
			initCmsPage();
		}
		if (typeof initSamplesCatPage != 'undefined') {
			initSamplesCatPage();
		}
		
		$('#popup-landing').remove();

		if(redirectURI == "/"){
			window.location = redirectURI;
		}
		
		return false;
	});
}

function AboutUsPage() {
	//Slider Lab Images
	function sliderNavUpdateText(e) {
		var $target = $(e.target);
		var $slider = $target.closest('.slider');
		var $text = $slider.find('.slider-nav-text');
		var label = $slider.find('.owl-item .slide').eq(e.item.index).data('label');

		$text.text(label);
	}

	//Slider labs
	var $sliderLabsDesktop = $('.slider-labs-desktop .slides');
	if ($sliderLabsDesktop.find('.slide').length > 1) {
		$sliderLabsDesktop.owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: false,
			autoplay: true,
			autoplayTimeout: 10000,
			autoplaySpeed: 1000,
			autoplayHoverPause: true
		});
	} else {
		$sliderLabsDesktop.addClass('owl-loaded');
	}

	var $sliderLabsMobile = $('.slider-labs-mobile .slides');
	if ($sliderLabsMobile.find('.slide').length > 1) {
		$sliderLabsMobile.owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: false,
			onInitialized: function(e) {
				sliderNavUpdateText(e);
			},
			onChanged: sliderNavUpdateText
		});
	} else {
		$sliderLabsMobile.addClass('owl-loaded');
		$('.slider-labs-mobile .slider-prev, .slider-labs-mobile .slider-next').hide();
	}

	$('.slider-labs-mobile .slider-prev').on('click', function (e) {
		e.preventDefault();

		$sliderLabsMobile.trigger('prev.owl.carousel');
	});

	$('.slider-labs-mobile .slider-next').on('click', function (e) {
		e.preventDefault();

		$sliderLabsMobile.trigger('next.owl.carousel');
	});

	$sliderLabsMobile.on('changed.owl.carousel', function(e) {
		var $text = $sliderLabsMobile.closest('.slider-labs-mobile').find('.slider-nav-text');
		var label = $sliderLabsMobile.find('.owl-item .slide').eq(e.item.index - 1).data('label');

		$text.text(label);
	});

	//Slider Souls
	var $sliderSoulsDesktop = $('.slider-souls-desktop .slides');
	if ($sliderSoulsDesktop.find('.slide').length > 1) {
		$sliderSoulsDesktop.owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: false,
			autoplay: true,
			autoplayTimeout: 10000,
			autoplaySpeed: 1000,
			autoplayHoverPause: true
		});
	} else {
		$sliderSoulsDesktop.addClass('owl-loaded');
	}

	var $sliderSoulsMobile = $('.slider-souls-mobile .slides');
	if($sliderSoulsMobile.find('.slide').length > 1) {
		$sliderSoulsMobile.owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: false,
			onInitialized: function(e) {
				sliderNavUpdateText(e);
			},
			onChanged: sliderNavUpdateText
		});
	} else {
		$sliderSoulsMobile.addClass('owl-loaded');
		$('.slider-souls-mobile .slider-prev, .slider-souls-mobile .slider-next').hide();
	}

	$('.slider-souls-mobile .slider-prev').on('click', function (e) {
		e.preventDefault();

		$sliderSoulsMobile.trigger('prev.owl.carousel');
	});

	$('.slider-souls-mobile .slider-next').on('click', function (e) {
		e.preventDefault();

		$sliderSoulsMobile.trigger('next.owl.carousel');
	});

	$sliderSoulsMobile.on('changed.owl.carousel', function(e) {
		var $text = $sliderSoulsMobile.closest('.slider-souls-mobile').find('.slider-nav-text');
		var label = $sliderSoulsMobile.find('.owl-item .slide').eq(e.item.index - 1).data('label');

		$text.text(label);
	});

	//Slider Collections
	var $sliderCollections = $('.slider-collections .slides');
	$sliderCollections.owlCarousel({
		items: 2,
		loop: true,
		nav: false,
		dots: true,
		margin: 10
	});

	//Slider Collections
	var $sliderCrafts = $('.slider-crafts .slides');
	$sliderCrafts.owlCarousel({
		items: 2,
		loop: true,
		nav: false,
		dots: true,
		margin: 10
	});
}

function initMobileMenu() {
	var $win = $(window);

	function mobileMenuOnResize() {
		var $mobileMenu = $('.menu');
		var visible = $mobileMenu.hasClass('visible');
		var height, offset;

		if (!visible) {
			$mobileMenu.css('opacity', '0').addClass('visible');
		} else {
			$mobileMenu.css('height', '');
		}

		height = $mobileMenu.outerHeight();
		$mobileMenu.data('height', height);

		if (!visible) {
			$mobileMenu.removeClass('visible').css('opacity', '');
		} else {
			$mobileMenu.css('height', height + 'px');
		}
	}

	$win.on('load resize', mobileMenuOnResize);
	mobileMenuOnResize();
}

function headerInitialize() {
	var $win = $(window);

	var oldWindowHeight = -1;
	function handleWindowResize() {
		var windowHeight = $win.height();

		if (windowHeight === oldWindowHeight) {
			return;
		}

		document.documentElement.style.setProperty('--app-window-height', windowHeight + 'px');

		oldWindowHeight = windowHeight;
	}

	$win.on('load resize', handleWindowResize);

	handleWindowResize();

	var $header = $('.header.header-sticky');

	if ($header.length) {
		var oldHeaderHeight = -1;
		function handleHeaderResize(headerHeight) {
			if (headerHeight === oldHeaderHeight) {
				return;
			}

			document.documentElement.style.setProperty('--app-header-height', headerHeight + 'px');

			oldHeaderHeight = headerHeight;
		}

		var headerResizeObserver = new ResizeObserver(function (mL) {
			var headerHeight = mL[0].contentRect.height;

			handleHeaderResize(headerHeight);
		});
		handleHeaderResize($header.height());
		headerResizeObserver.observe($header[0]);
	}
}

function initHomeSlider() {
	var $win = $(window);
	var $sliderHome = $('.slider-home .slides');
	var $sliderHomeVideo;

	var timeoutId;
	var startTime;
	var remainingTime;
	var maxVideoPlays = 3;
	var sliderViewedList = getCookieWithHelper(true, 'slider_home_viewed_list');
	var sliderViewedSet = new Set(sliderViewedList);

	if ($win.width() < 1024) {

		var target = document.querySelector('.slider-home');

		var observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (!entry.isIntersecting) {
					handleTouchstart()
				} else {
					handleTouchend()
				}
			});
		})
		observer.observe(target);
	}

	var $slideAssets = $sliderHome.find('.slide-asset--mobile.slide-video');
	$slideAssets.each(function(i, elem) {
		var $slideAsset = $(elem);

		var $asset = $slideAsset.find('.bg-asset');
		var key = $asset.closest('.slide').data('key');
		var src = $asset.find('source').attr('src');
		var contentId = key + '_' + src;
		var imageUrl = $asset.data('image') || $asset.attr('poster');

		if (sliderViewedSet.has(contentId) && imageUrl) {
			$slideAsset
				.removeClass('slide-video')
				.addClass('slide-image');
			$slideAsset[0].style = '';

			var imageElem = document.createElement('img');
			imageElem.onerror = function (err) { console.error(err); };
			imageElem.className = 'bg-asset bg-image';
			imageElem.alt = '';
			imageElem.src = imageUrl;
			imageElem.width = $asset.data('image-width');
			imageElem.height = $asset.data('image-height');
			$asset.replaceWith(imageElem);
		} else {
			$slideAsset.css('background-image', 'url(' + $asset.attr('poster') + ')');

			var videoElem = document.createElement('video');

			Array.prototype.forEach.call($asset[0].attributes, function (attribute) {
				if (/^(?:data-|style)/i.test(attribute.name)) {
					return;
				}

				videoElem.setAttribute(attribute.name, attribute.value);
			});

			videoElem.muted = true;
			videoElem.innerHTML = $asset[0].innerHTML;

			$asset.replaceWith(videoElem);
		}
	});

	function pauseSlider() {
		if (typeof $sliderHomeVideo !== 'undefined') {
			$sliderHomeVideo.off('ended');
			var video = $sliderHomeVideo[0];

			video.pause();
		} else {
			clearTimeout(timeoutId);
			remainingTime = 0;
		}
	}

	function handleInitialized() {
		var $doc = $(document);

		var wasPlaying = false;

		$doc.on('visibilitychange', function () {
			var video;

			if (document.hidden) {
				if (typeof $sliderHomeVideo !== 'undefined') {
					video = $sliderHomeVideo[0];

					wasPlaying = !video.paused;

					if (wasPlaying) {
						video.pause();
					}
				} else {
					wasPlaying = false;
				}
			} else {
				if ($sliderHomeVideo && wasPlaying) {
					video = $sliderHomeVideo[0];

					video.play();
				}
			}
		});

		$('.slider-home .slider-thumb')
			.on('mouseenter', function (e) {
				if ($win.width() < 1024) {
					return;
				}

				var $target = $(e.currentTarget);
				var currentSlide = $target.index();

				$sliderHome.trigger('to.owl.carousel', [currentSlide]);
			})
			.on('click', function (e) {
				if ($win.width() >= 1024) {
					return;
				}

				var $target = $(e.currentTarget);
				var $link = $target.closest('.homepage-link-btn');

				if ($win.width() < 768 && $link.length) {
					pauseSlider();
					var url = $link.attr('href');
					window.location = url;
					return;
				}

				var currentSlide = $target.index();

				$sliderHome.trigger('to.owl.carousel', [currentSlide]);
			});

		$('.slider-home .slider-thumb a.slider-thumb-link')
			.on('click', function(e) {
				// Allows the thumb images to link out
				e.preventDefault();
				location.href = $(this).attr('href');
			});
	}

	function handleVideoEnded(evt) {
		var $video = $(evt.target);
		var counter = $video.data('counter');

		counter--;

		$video.data('counter', counter);

		var video = $video[0];
		video.pause();
		video.currentTime = 0;

		if (counter > 0) {
			video.play();
			return;
		}

		$video.off('ended', handleVideoEnded);
	}

	function handleChanged(e) {
		var index = e && e.item && e.item.index;

		if (typeof index !== 'number') {
			return;
		}

		var video;
		var $video = $sliderHome.find('.owl-item').eq(index).find('.slide-asset.slide-video:visible .bg-video');

		if ($win.width() >= 1024) {
			if (typeof $sliderHomeVideo !== 'undefined') {
				video = $sliderHomeVideo[0];

				if (timeoutId) {
					clearTimeout(timeoutId);
				}

				video.pause();
				video.currentTime = 0;

				$sliderHomeVideo.off('ended', handleVideoEnded);
			}

			if ($video.length) {
				video = $video[0];

				if (video.paused) {
					$video.data('counter', maxVideoPlays);
					$video.on('ended', handleVideoEnded);

					video.play();

					$sliderHomeVideo = $video;
					remainingTime = 0;
					startTime = undefined;
					timeoutId = undefined;
				}
			}
		} else {
			pauseSlider();

			if ($video.length) {
				video = $video[0];

				$video.on('ended', function () {
					video.pause();
					video.currentTime = video.duration;
					var src = $video.find('source').attr('src');
					var key = $video.closest('.slide').data('key');
					var contentId = key + '_' + src;
					sliderViewedSet.add(contentId);
					setCookieWithHelper(true, 'slider_home_viewed_list', Array.from(sliderViewedSet.keys()));

					$sliderHome.trigger('next.owl.carousel');
				});

				video.currentTime = 0;
				video.play();

				$sliderHomeVideo = $video;
				remainingTime = 0;
				startTime = undefined;
				timeoutId = undefined;
			} else {
				$sliderHomeVideo = undefined;
				remainingTime = 5000;
				startTime = Date.now();
				timeoutId = setTimeout(function () {
					$sliderHome.trigger('next.owl.carousel');
				}, remainingTime);
			}
		}
	}

	function handleTouchstart() {
		if ($win.width() >= 768) {
			return;
		}

		if (typeof $sliderHomeVideo !== 'undefined') {
			$sliderHomeVideo[0].pause();
		} else {
			clearTimeout(timeoutId);
			remainingTime -= Date.now() - startTime;
		}
	}

	function handleTouchend() {
		if ($win.width() >= 768) {
			return;
		}

		if (typeof $sliderHomeVideo !== 'undefined') {
			$sliderHomeVideo[0].play();
		} else {
			startTime = Date.now();
			timeoutId = setTimeout(function () {
				$sliderHome.trigger('next.owl.carousel');
			}, remainingTime);
		}
	}

	$sliderHome
		.on('touchstart', handleTouchstart)
		.on('touchend', handleTouchend);

	$sliderHome.owlCarousel({
		items: 1,
		autoplay: false,
		smartSpeed: 1000,
		controls: false,
		loop: true,
		dots: true,
		dotsContainer: '.slider-paging .slider-thumbs',
		responsive: {
			0: {
				mouseDrag: true,
				touchDrag: true,
				animateOut: 'slideOutLeft',
				animateIn: 'slideInRight',
			},
			1025: {
				mouseDrag: false,
				touchDrag: false,
				animateOut: 'fadeOut',
				animateIn: 'fadeIn',
			}
		},
		onInitialized: handleInitialized,
		onChanged: handleChanged
	});

	$('.btn-menu').on('click', (event) => {
		if (event.target.classList.contains('active')){
			handleTouchend()
		} else {
			handleTouchstart()
		}
	})
	$('.btn-search').on('click', () => {
		handleTouchstart()
	})

	$('body').on('click', '.mobile-search-close-btn', () => {
		handleTouchend()
	})
}
function togglePopup(target, trigger, flag) {
	var $popup = $(target);

	if (typeof flag === 'undefined') {
		flag = !$popup.hasClass('visible');
	}

	$popup.toggleClass('visible', flag);

	var $globalElements = $('.wrapper,.mobile-search-menu');
	var $focusable;

	if (flag) {
		$popup.data('trigger', trigger);

		$focusable = $popup.find(':tabbable:visible').first();
		$focusable.focus();

		$globalElements.attr('inert', '');
	} else {
		$globalElements.removeAttr('inert');

		trigger = $popup.data('trigger');
		$focusable = $(trigger);

		if (!$focusable.length) {
			$focusable = $(':tabbable:visible').first();
		}

		$focusable.focus();

		$popup.data('trigger', null);
	}
}

function showPopup(target, trigger) {
	togglePopup(target, trigger, true);
}

function hidePopup(target, trigger) {
	togglePopup(target, trigger,  false);
}